<template lang="pug">
  svg
    defs
      radialGradient#gradient1(cx="50%" cy="50%" r="50%" gradientUnits="objectBoundingBox")
        stop(offset="0%" style="stop-color:rgb(20,71,153);")
        stop(offset="100%" style="stop-color:rgb(17,23,51);")
      radialGradient#gradient2(cx="50%" cy="50%" r="50%" gradientUnits="objectBoundingBox")
        stop(offset="0%" style="stop-color:rgb(17,23,51); stop-opacity:0")
        stop(offset="100%" style="stop-color:rgb(17,23,51); stop-opacity:0.75")
      pattern#pattern1(x="0" y="0" width="6" height="6" patternUnits="userSpaceOnUse")
        circle(cx="1.5" cy="1.5" r="0.75" fill="#000" fill-opacity="1")
        circle(cx="1.5" cy="2" r="0.75" fill="#fff" fill-opacity="0.25")
        circle(cx="4.5" cy="4.5" r="0.75" fill="#000" fill-opacity="1")
        circle(cx="4.5" cy="5" r="0.75" fill="#fff" fill-opacity="0.25")
      pattern#pattern2(x="0" y="0" width="1000" height="1000" patternUnits="userSpaceOnUse")
        template(v-for="(index) in 24")
          line(:x1="index * 40" :x2="index * 40 - 1" :y1="startPos(index) + 250"  :y2="endPos(index) + 250" stroke="#11DDFF" stroke-width="0.5")
          line(:x1="index * 40" :x2="index * 40 - 1" :y1="startPos(index) + 750"  :y2="endPos(index) + 750" stroke="#11DDFF" stroke-width="0.5")
          line(:y1="index * 40" :y2="index * 40 - 1" :x1="startPos(index) + 250"  :x2="endPos(index) + 250" stroke="#11DDFF" stroke-width="0.5")
          line(:y1="index * 40" :y2="index * 40 - 1" :x1="startPos(index) + 750"  :x2="endPos(index) + 750" stroke="#11DDFF" stroke-width="0.5")
</template>
<script>
import SimplexNoise from "simplex-noise";
export default {
  data() {
    return {
      simplex: new SimplexNoise(Math.random),
      tick_id: null,
      timestamp: 0,
      frame: 0
    };
  },
  mounted() {
    this.timestamp = Date.now();
    this.tick();
  },
  methods: {
    tick() {
      this.frame += Date.now() - this.timestamp;
      this.timestamp = Date.now();
      this.tick_id = requestAnimationFrame(this.tick);
    },
    startPos(index) {
      const pos = this.simplex.noise2D(this.frame * 0.0001, index);
      return pos * 500;
    },
    endPos(index) {
      const pos = this.simplex.noise2D(index, this.frame * 0.0001);
      return pos * 500;
    }
  }
};
</script>
